import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

// Test Suite Result Query
const fetchPublicTestSuiteResult = async ({ tsid, tsrid, companyId, token }) => {
  if (!tsid || !companyId || !token) throw new Error("Missing required parameters");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTestSuiteResult&companyid=${companyId}&token=${token}&idtest_suite=${tsid}&TSRId=${tsrid}`,
  );

  return response.data;
};

export const usePublicTestSuiteResultQuery = (tsid, tsrid, companyId, token, options) => {
  return useQuery({
    queryKey: ["publicTestSuiteResult", tsid, companyId, token],
    queryFn: () => fetchPublicTestSuiteResult({ tsid, tsrid, companyId, token }),
    enabled: options?.enabled && !!tsid && !!companyId && !!token,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

// Test Case Results From Test Suite Query
const fetchPublicTestCaseRecords = async ({ id, criteria, companyId, token }) => {
  if (!id || !companyId || !token) throw new Error("Missing required parameters");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTestCaseResultFromTestSuiteResult&companyid=${companyId}&token=${token}&testSuiteResultId=${id}&criteria=${criteria}`,
  );

  return response.data;
};

export const usePublicTestCaseResultsFromTestSuiteQuery = (id, criteria, companyId, token, options) => {
  return useQuery({
    queryKey: ["publicTestCaseResultsFromTS", id, companyId, token],
    queryFn: () => fetchPublicTestCaseRecords({ id, criteria, companyId, token }),
    enabled: options?.enabled && !!id && !!companyId && !!token,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

// Error Codes Query
const fetchPublicErrorCodes = async ({ id, companyId, token }) => {
  if (!id || !companyId || !token) throw new Error("Missing required parameters");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getErrorCodesForTestSuite&companyid=${companyId}&token=${token}&testSuiteResultId=${id}`,
  );

  return response.data;
};

export const usePublicErrorCodesQuery = (id, companyId, token, options) => {
  return useQuery({
    queryKey: ["publicErrorCodes", id, companyId, token],
    queryFn: () => fetchPublicErrorCodes({ id, companyId, token }),
    enabled: options?.enabled && !!id && !!companyId && !!token,
  });
};

// Status Pattern Query
const fetchPublicStatusPattern = async ({ testSuiteResultId, companyId, token }) => {
  if (!testSuiteResultId || !companyId || !token) throw new Error("Missing required parameters");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getStatusPatternCountsForTestSuiteResult&companyid=${companyId}&token=${token}&testSuiteResultId=${testSuiteResultId}`,
  );

  return response.data;
};

export const usePublicStatusPatternQuery = (testSuiteResultId, companyId, token, options) => {
  return useQuery({
    queryKey: ["publicStatusPattern", testSuiteResultId, companyId, token],
    queryFn: () => fetchPublicStatusPattern({ testSuiteResultId, companyId, token }),
    enabled: options?.enabled && !!testSuiteResultId && !!companyId && !!token,
  });
}; 